// Google Ads conversion helpers.
// The global tag (AW-18348994888) is loaded in public/index.html.

// "Submit lead form" conversion — fired on real lead actions:
//  - a tenant reveals an owner's contact
//  - an owner publishes a new listing
export function fireLeadConversion() {
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-18348994888/-EjbCOLLtuscEMjiva1E",
      });
    }
  } catch (_) {
    /* gtag may be blocked/not ready — silent no-op */
  }
}

// Generic GTM/GA4 event push. Used by the AI Search Assistant for:
//  ai_search_started, ai_search_completed, ai_search_no_results,
//  ai_search_listing_clicked, ai_search_alert_signup
export function fireEvent(name, params = {}) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
    if (typeof window.gtag === "function") window.gtag("event", name, params);
  } catch (_) {
    /* analytics blocked/not ready — silent no-op */
  }
}
